import React from 'react'
import { GridColDef, GridRenderCellParams, GridValueGetterParams } from '@mui/x-data-grid-pro'
import { colors } from 'src/theme'
import { Typography } from '@mui/material'
import { TeamMemberInvite } from 'src/interfaces/team'
import { TableMarketLabels } from 'src/components/team/grid/TableMarketLabels'
import { TableLabel } from 'src/components/shared/label/TableLabel'
import { CustomersMinor } from '@shopify/polaris-icons'
import tw from 'twin.macro'
import { gridFormatters, gridValueGetters } from 'src/utils/grid'
import { ExpiresInviteChip } from 'src/components/team/grid/ExpiresInviteChip'
import { TeamMemberInviteActionButton } from 'src/components/team/tables/team-member-invites-table/TeamMemberInviteActionButton'
import { formatFullNameWithEmail, removeUnderscoresAndCapitalize } from 'src/utils/baseUtils'

export const teamMemberInvitesBaseColumns: Array<GridColDef> = [
  {
    field: 'userName',
    headerName: 'User name',
    flex: 3,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<TeamMemberInvite>) =>
      formatFullNameWithEmail(params.row.firstName, params.row.lastName, params.row.email),
    renderCell: (params) => (
      <div>
        <Typography variant="h6" color={colors.BASICS_BLACK}>
          {`${params.row.firstName} ${params.row.lastName}`}
        </Typography>
        <Typography variant="body2" color={colors.SHADES_GREY_400}>
          {params.row.email}
        </Typography>
      </div>
    ),
  },
  {
    field: 'createdAt',
    headerName: 'Invited',
    flex: 2,
    sortable: true,
    valueGetter: gridValueGetters.parseDate,
    valueFormatter: gridFormatters.formatSimpleDate,
  },
  {
    field: 'expiresAt',
    headerName: 'Expires in',
    flex: 2,
    sortable: true,
    valueGetter: gridValueGetters.parseDate,
    valueFormatter: gridFormatters.formatDateOnly,
    renderCell: (params: GridRenderCellParams<TeamMemberInvite>) => (
      <ExpiresInviteChip expiresAt={params.row.expiresAt} />
    ),
  },
  {
    field: 'markets',
    headerName: 'Markets',
    flex: 3,
    sortable: false,
    renderCell: (params: GridRenderCellParams<TeamMemberInvite>) => (
      <TableMarketLabels markets={params.row.marketIds} isAllMarkets={params.row.allMarkets} />
    ),
  },
  {
    field: 'role',
    headerName: 'Role',
    flex: 2,
    sortable: false,
    valueGetter: (params: GridValueGetterParams<TeamMemberInvite>) =>
      removeUnderscoresAndCapitalize(params.row.role),
    renderCell: (params: GridRenderCellParams<TeamMemberInvite>) => (
      <TableLabel
        label={params.value}
        beforeIcon={<CustomersMinor width={20} fill={colors.BASICS_BLACK} />}
        className={tw`bg-[#EDEDED] rounded pl-1 pr-2 pt-0 pb-0`}
        textColor={colors.SHADES_GREY_500}
      />
    ),
  },
]

export const teamMemberInvitesActionColumn: GridColDef<TeamMemberInvite> = {
  field: 'actions',
  headerName: 'Actions',
  flex: 1,
  sortable: false,
  renderCell: (params) => <TeamMemberInviteActionButton teamMemberInvite={params.row} />,
}
